"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const detect_utils_1 = require("@/common/detect_utils");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const functions_2 = require("./functions");
function default_1({ isEdit, closeDialog, resetFormValues, profileForm, }) {
    const { formState: { dirtyFields, defaultValues }, watch, handleSubmit, } = profileForm;
    const { t } = (0, react_i18next_1.useTranslation)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const setUserInfo = (0, recoil_1.useSetRecoilState)(userInfoState_1.default);
    const invalidateUserInfo = () => setUserInfo(prev => (Object.assign(Object.assign({}, prev), { ready: false })));
    const unmountRef = (0, detect_utils_1.useUnmountRef)();
    const [uploading, setUploading] = (0, react_1.useState)(false);
    const enableUploadAfterDelay = () => (0, functions_1.delay)(300).then(() => {
        if (!unmountRef.current) {
            setUploading(false);
        }
    });
    const errorConfirm = ({ description = (0, string_utils_1.logoutRequiredMsg)(), action = () => setUploading(false), } = {}) => {
        confirm({
            description,
            cancellationButtonProps: { style: { display: 'none' } },
            allowClose: false,
        })
            .then(action)
            .catch(() => { });
    };
    const getErrorProps = (alertType) => {
        switch (alertType) {
            case 40000:
                return { description: functions_2.profileErrors.lengthLimitName() };
            case 40001:
                return {
                    description: functions_2.profileErrors.exceededProfile(),
                    action: () => {
                        (0, functions_2.getProfile)({
                            retryCount: 5,
                            onSuccess: invalidateUserInfo,
                            onError: () => errorConfirm({ action: functions_1.logout }),
                        });
                        closeDialog();
                        enableUploadAfterDelay();
                    },
                };
            case 40002:
                return {
                    description: functions_2.profileErrors.noAuthority(),
                    action: () => window.location.reload(),
                };
            case 40003:
                return {
                    description: functions_2.profileErrors.dissonantProfile(),
                    action: () => (0, functions_2.getProfile)({
                        retryCount: 5,
                        onSuccess: () => {
                            invalidateUserInfo();
                            enableUploadAfterDelay();
                        },
                        onError: () => errorConfirm({ action: functions_1.logout }),
                    }),
                };
            case 40004:
                return { description: functions_2.profileErrors.duplicateName() };
            case 40005:
                return { description: functions_2.profileErrors.requiredName() };
            case 40006:
                return { description: functions_2.profileErrors.patternName() };
            case 40007:
                return { description: functions_2.profileErrors.lengthLimitUid() };
            case 40008:
                return { description: functions_2.profileErrors.patternUid() };
            case 40009:
                return { description: functions_2.profileErrors.duplicateUid() };
            case 400010:
                return { description: functions_2.profileErrors.requiredUid() };
            default:
                return { action: functions_1.logout };
        }
    };
    const submitProfile = (inputData) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const { name, uid, uploadedImg } = inputData;
        const lowerCasedUid = String(uid).toLowerCase();
        const isUidChanged = dirtyFields.uid && ((_a = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.uid) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== lowerCasedUid;
        if (dirtyFields.name || isUidChanged || dirtyFields.uploadedImg) {
            setUploading(true);
            const formData = new FormData();
            dirtyFields.name && formData.append('name', name);
            isUidChanged && formData.append('uid', lowerCasedUid);
            dirtyFields.uploadedImg && formData.append('thumbnail', uploadedImg);
            const updateFormData = isEdit ? api_1.patchFormData : api_1.postFormData;
            yield updateFormData(`/api/v1/profile/auth/${watch('id') || ''}`, formData)
                .then(res => {
                if (res.status === 200 || res.status === 201) {
                    invalidateUserInfo();
                }
                closeDialog();
                enableUploadAfterDelay();
            })
                .catch(err => {
                var _a, _b, _c;
                const alertType = (_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.alert_type;
                errorConfirm(getErrorProps(alertType));
            });
        }
        else {
            closeDialog();
        }
    });
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', columnGap: '12px', width: '100%', margin: '0 -2px' } }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: "grey_outlined", fullWidth: true, sx: { height: '40px', fontWeight: 400, color: 'black !important' }, onClick: () => {
                    closeDialog();
                    (0, functions_1.delay)(300).then(resetFormValues);
                }, disabled: uploading }, { children: t('취소') })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: "orange_filled", fullWidth: true, sx: { height: '40px' }, onClick: handleSubmit(submitProfile), disabled: uploading }, { children: uploading ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { color: "info", size: 20, thickness: 4 })) : ((0, jsx_runtime_1.jsx)("span", { children: t('저장') })) }))] })));
}
exports.default = default_1;
